// Formulaire de connexion, branché sur POST /auth/login.php.
// Logique identique à l'ancienne version : seule la présentation change.
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Field from './Field'
import { useAuth } from '../../lib/AuthContext'
import { useT } from '../../lib/i18n'
import { whatsappLink } from '../../lib/support'

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export default function LoginForm () {
  const t = useT()
  const { login } = useAuth()
  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [pass, setPass] = useState('')
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  async function onSubmit (ev) {
    ev.preventDefault()
    const e = {}
    if (!EMAIL_RE.test(email)) e.email = t.errors.email
    if (!pass) e.pass = t.errors.password
    setErrors(e)
    if (Object.keys(e).length) return

    setLoading(true)
    try {
      await login(email.trim(), pass)
      navigate('/dashboard')
    } catch (err) {
      setErrors({ form: err.message })
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={onSubmit} noValidate className="rg-f">
      <Field
        id="email" label={t.login.emailLabel} type="email"
        value={email} onChange={setEmail}
        placeholder={t.login.emailPlaceholder} autoComplete="email"
        error={errors.email}
      />

      <Field
        id="pass" label={t.login.passLabel} type="password"
        value={pass} onChange={setPass}
        placeholder={t.login.passPlaceholder} autoComplete="current-password"
        error={errors.pass}
      />

      <div className="u-fld__row">
        <a href={whatsappLink(t.login.forgotMsg(email))} target="_blank" rel="noopener noreferrer">{t.login.forgot}</a>
      </div>

      {errors.form && <p className="u-fld__err u-fld__err--form">{errors.form}</p>}

      <button type="submit" className="rg-go rg-go--center" disabled={loading}>
        <span>{loading ? t.login.submitting : t.login.submit}</span>
      </button>
    </form>
  )
}
